import {NetUtils} from '../../classes/utils/net.utils.js';
import {config} from '../config.js';

export var RegistrationAPI = {
    
    account: function( firstname, lastname, email, password )
    {
        return new Promise( ( resolve, reject ) => 
        {
            // get the IP address of the current user
            NetUtils.getIPAddress()
            // if the IP address is retrieved successfully
            .then( ( ip ) => {
                var xhr = new XMLHttpRequest();
                xhr.open( 'POST', config.baseUrl + '/register/account', true );
                xhr.setRequestHeader( 'Content-Type', 'application/json' );
                xhr.setRequestHeader( 'x-forwarded-for', ip  );
                xhr.setRequestHeader( 'firstname', firstname  );
                xhr.setRequestHeader( 'lastname', lastname  );
                xhr.setRequestHeader( 'email', email  );
                xhr.setRequestHeader( 'password', password  );
                xhr.setRequestHeader( 'Accept', 'application/json' );
                xhr.timeout = 5000;
    
                xhr.onload = function() 
                {
                    if( xhr.status === 200 ) 
                    {
                        resolve( JSON.parse( xhr.responseText ) );
                    } 
                    else 
                    {
                        reject( xhr.statusText );
                    }
                };
                xhr.send();
            } )
            // if the IP address is not retrieved successfully
            .catch( ( error ) => { reject( error ); } );
        } );
    },

    modify: function( email, firstname, lastname )
    {
        return new Promise( ( resolve, reject ) => 
        {
            // get the IP address of the current user
            NetUtils.getIPAddress()
            // if the IP address is retrieved successfully
            .then( ( ip ) => {
                var xhr = new XMLHttpRequest();
                xhr.open( 'POST', config.baseUrl + '/register/modify', true );
                xhr.setRequestHeader( 'Content-Type', 'application/json' );
                xhr.setRequestHeader( 'x-forwarded-for', ip  );
                xhr.setRequestHeader( 'email', email  );
                xhr.setRequestHeader( 'firstname', firstname );
                xhr.setRequestHeader( 'lastname', lastname );
                xhr.setRequestHeader( 'token', token );
                xhr.setRequestHeader( 'Accept', 'application/json' );
                xhr.timeout = 5000;
    
                xhr.onload = function() 
                {
                    if( xhr.status === 200 ) 
                    {
                        resolve( JSON.parse( xhr.responseText ) );
                    } 
                    else 
                    {
                        reject( xhr.statusText );
                    }
                };
                xhr.send();
            } )
            // if the IP address is not retrieved successfully
            .catch( ( error ) => { reject( error ); } );
        } );
    },

    licence: function( email, licence )
    {
        return new Promise( ( resolve, reject ) => 
        {
            // get the IP address of the current user
            NetUtils.getIPAddress()
            // if the IP address is retrieved successfully
            .then( ( ip ) => {
                var xhr = new XMLHttpRequest();
                xhr.open( 'POST', config.baseUrl + '/register/licence', true );
                xhr.setRequestHeader( 'Content-Type', 'application/json' );
                xhr.setRequestHeader( 'x-forwarded-for', ip  );
                xhr.setRequestHeader( 'email', email  );
                xhr.setRequestHeader( 'licence', licence  );
                xhr.setRequestHeader( 'Accept', 'application/json' );
                xhr.setRequestHeader( 'token', token );
                xhr.timeout = 5000;
    
                xhr.onload = function() 
                {
                    if( xhr.status === 200 ) 
                    {
                        resolve( JSON.parse( xhr.responseText ) );
                    } 
                    else 
                    {
                        reject( xhr.statusText );
                    }
                };
                xhr.send();
            } )
            // if the IP address is not retrieved successfully
            .catch( ( error ) => { reject( error ); } );
        } );
    }
}